namespace Matrix.Visualizer {
    export interface GraphInstanceForm {
        InstanceKey: Serenity.StringEditor;
        GraphKey: Serenity.StringEditor;
        ThemeKey: Serenity.StringEditor;
        RowId: Serenity.IntegerEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class GraphInstanceForm extends Serenity.PrefixedContext {
        static formKey = 'Visualizer.GraphInstance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!GraphInstanceForm.init)  {
                GraphInstanceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(GraphInstanceForm, [
                    'InstanceKey', w0,
                    'GraphKey', w0,
                    'ThemeKey', w0,
                    'RowId', w1,
                    'Version', w2,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3
                ]);
            }
        }
    }
}
